
import React from 'react';
import { GoogleIcon, LogoIcon } from '../components/icons';

interface ConnectViewProps {
  onConnect: () => void;
}

const ConnectView: React.FC<ConnectViewProps> = ({ onConnect }) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4 text-center">
      <div className="bg-base-200 p-8 rounded-2xl shadow-2xl max-w-md w-full border border-base-300">
        <div className="flex justify-center items-center gap-3 mb-4">
          <LogoIcon className="w-10 h-10 text-brand-primary" />
          <h1 className="text-3xl font-bold text-text-primary">QuantumLeap AI</h1>
        </div>
        <p className="text-text-secondary mb-8">
          Your all-in-one AI marketing assistant. Connect your Google account to get deep insights from Analytics, manage your GTM container, and generate compelling ad copy, images, and videos to outperform the competition.
        </p>
        
        <button
          onClick={onConnect}
          className="w-full bg-brand-primary hover:bg-brand-secondary text-white font-bold py-3 px-4 rounded-lg flex items-center justify-center gap-3 transition-colors duration-300"
        >
          <GoogleIcon className="w-5 h-5" />
          Connect with Google
        </button>
        <p className="text-xs text-base-300 mt-6">
          By connecting, you agree to our Terms of Service. In a real app, this would initiate the Google OAuth2 flow for secure authentication.
        </p>
      </div>
    </div>
  );
};

export default ConnectView;